import moment from 'moment'
import 'owl.carousel';


jQuery(document).ready(function ($) {


  // MOBILE MENU
  $('.mobile-menu-icon').on('click', function () {
    $("header").toggleClass('active')
    $(".menu-wrapper").toggleClass('active')
    $(".social-wrapper").toggleClass('active')
    $(".line").toggleClass('active')
  })

  $('.nav-button').on('click', function () {
    if ($('#nav-menu').hasClass('active')) {
      $("header").toggleClass('active')
      $(".menu-wrapper").toggleClass('active')
      $(".social-wrapper").toggleClass('active')
      $(".line").toggleClass('active')
    }
  })


  // TOURDATES IMPORT
  $.ajax({
    url: `https://rest.bandsintown.com/artists/id_15507910/events?app_id=45PRESS_shane-profitt`,
    method: 'GET',
    dataType: 'json',
    error: () => alert('Error fetching events!'),
    success: data => {
      const eventsContainer = $('#tour-dates');

      if (data.length) {
        console.log('data', data)
        // Generate HTML for each event and append to the events container
        const html = data.map(event => generateEventHtml(event)).join('');
        eventsContainer.html(html);

        // Hide the "toggle dates" button if fewer than 9 events are available
        if (data.length < 9) {
          $("#toggle-dates").hide();
        }
      } else {
        // Display message if no events are found
        eventsContainer.html('<span class="no-events">Check back soon for new shows!</span>');
      }
    }
  });

  function generateEventHtml(event) {
    const eventDate = moment(event.datetime).format('MMMM DD, YYYY');
    const venueName = event.venue.name;
    const venueRegion = event.venue.region !== null && event.venue.region !== '' ? event.venue.region : event.venue.country;
    const venueLocation = event.venue.city + ', ' + venueRegion;


    // Get the full lineup from the event
    const lineup = event.lineup || [];
    // Slice the lineup so we only show artists after the headliner
    let additionalArtists = '';

    // Only show the additional artists if there is more than one artist in the lineup
    if (lineup.length > 1) {
      additionalArtists = 'With ' + lineup.slice(1).join(', ');
    }

    const offersHtml = event.offers.map(offer =>
      `<a href="${offer.url}" target="_blank" class="link btn">${offer.type}</a>`
    ).join('');

    return `
    <div class="event-group">
      <div class="event-sub-group">
        <div class="event-date">${eventDate}</div>
        <div class="event-additional-artists">${additionalArtists}</div>
      </div>
      <div class="event-sub-group">
        <div class="event-venue">${venueName}</div>
        <div class="event-location">${venueLocation}</div>
      </div>
      <div class="event-links">${offersHtml}</div>
    </div>
  `;
  }


  // CAROUSEL

  function createMusicCarousel() {
    const musicCarousel = $("#music-carousel")
    const leftArrow = '<div class="owl-custom-nav-prev arrow"><i class="fa-solid fa-chevron-left"></i></div>'
    const rightArrow = '<div class="owl-custom-nav-next arrow"><i class="fa-solid fa-chevron-right"></i></div>'

    musicCarousel.owlCarousel({
      loop: true,
      nav: true,
      dots: false,
      items: 1,
      startPosition: 0,
      autoplayTimeout: 3000,
      autoplaySpeed: 500,
      margin: 55,
      center: true,
      navText: [
        leftArrow,
        rightArrow
      ]
    })
  }
  createMusicCarousel()



  // NEWSLETTER SUBMIT
  $("#shane-profitt-email").on("submit", function (e) {
    e.preventDefault();

    // Get all the form user submitted data and get it ready to be sent.
    var data = $(this).serialize();
    
    // POST all the data to the SMF submission endpoint URL.
    $.ajax({
      type: "POST",
      url: "https://subs.sonymusicfans.com/submit",
      dataType: "json",
      data: data,
      xhrFields: {
        withCredentials: false
      },
      success: function (data) {
        // Do things on successful submission.
        alert("Submitted!");
      },
      error: function (err) {
        // Do things when submission has an error.
        alert("An error has occured!");
      }
    });
  });

});